import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { connectDatabaseEmulator, getDatabase, provideDatabase } from '@angular/fire/database';
import { connectFunctionsEmulator, getFunctions, provideFunctions } from '@angular/fire/functions';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/current';
import { REGION } from './constants';
import { routes } from './app.routes';
//import { DatePipe } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    //{ provide: LOCALE_ID, useValue: 'pt-BR' },
    //DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideHttpClient(withInterceptorsFromDi()),
    provideAuth(() => {
      const authF = getAuth();
      if (environment.useEmulators) {
        connectAuthEmulator(authF, 'http://127.0.0.1:9105', { disableWarnings: true });
      }
      return authF;
    }),
    provideDatabase(() => {
      const dbf = getDatabase();
      if (environment.useEmulators) {
        connectDatabaseEmulator(dbf, '127.0.0.1', 9005);
      }
      return dbf;
    }),
    provideStorage(() => {
      const stoF = getStorage();
      if (environment.useEmulators) {
        connectStorageEmulator(stoF, '127.0.0.1', 9205);
      }
      return stoF;
    }),
    provideAnalytics(() => getAnalytics()),
    provideFunctions(() => {
      const funcF = getFunctions(undefined, REGION);
      if (environment.useEmulators) {
        connectFunctionsEmulator(funcF, '127.0.0.1', 5005);
      }
      return funcF;
    }),
    providePerformance(() => getPerformance()),
    importProvidersFrom(
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      })
    ),
    provideRouter(routes),
  ],
};
